import { z } from "zod";
import { createValidateDateOfBirth, createValidateSSN } from "@lending/utils/validators";
import type { ReactLocalization } from "@fluent/react";
import type { Institution } from "@lending/types";

export function createPersonalInfoReviewSchema(l10n: ReactLocalization, institution: Institution) {
  const requiredMessage = l10n.getString("error-required", null, "Required");

  return z.object({
    first_name: z.string().min(1, { message: requiredMessage }),
    last_name: z.string().min(1, { message: requiredMessage }),
    tax_id: createValidateSSN(l10n),
    date_of_birth: createValidateDateOfBirth(l10n, institution),
    street: z.string().min(1, { message: requiredMessage }),
    street2: z.string(),
    city: z.string().min(1, { message: requiredMessage }),
    region: z.string().min(1, { message: requiredMessage }),
    postal_code: z.string().min(1, { message: requiredMessage }),
  });
}
